<template>
  <div class="md:container mx-auto">
    <div class="mt-4">
      <subtitle>{{ title }}</subtitle>
      <div v-if="mobileView">
        <grid-view :movies="movieData" :isLoading="isLoading" />
      </div>
      <div v-else>
        <grid-view
          :movies="movieData"
          :isLoading="isLoading"
          v-if="view === 'grid'"
        />
        <list-view
          :movies="movieData"
          :isLoading="isLoading"
          v-if="view === 'list'"
        />
      </div>
    </div>
    <div class="mt-20 w-full flex justify-center">
      <v-pagination
        v-if="movieData.total_pages > 1"
        v-model="movieData.page"
        :pages="movieData.total_pages"
        :range-size="1"
        :hideFirstButton="true"
        :hideLastButton="true"
        active-color="#DCEDFF"
        @update:modelValue="updateHandler"
        class="custom-pagination"
      />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import GridView from "./GridView.vue";
import ListView from "./ListView.vue";
export default {
  name: "template-view",
  components: { GridView, ListView },
  props: {
    title: {
      type: String,
      default: "",
    },
    isLoading: { type: Boolean },
    movies: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const movieData = computed(() => props.movies);
    let view = computed(() => store.state.view);
    const mobileView = computed(() => store.state.onMobile);

    let movie_store = localStorage.getItem("movie_store");
    if (movie_store) {
      movie_store = JSON.parse(movie_store);
    }

    const updateHandler = (val) => {
      let newStore = {
        ...movie_store,
        page: val,
      };
      localStorage.setItem("movie_store", JSON.stringify(newStore));
      router.push({
        path: route.path,
        query: {
          ...route.query,
          page: val,
        },
      });
    };

    return { mobileView, view, updateHandler, movieData };
  },
};
</script>
